// extracted by mini-css-extract-plugin
export default {"button":"icv2OJ"};